module.exports = __webpack_public_path__ + "img/arrow-bigger-hover.fea1920a.svg";